import { render, staticRenderFns } from "./DashboardMatters.vue?vue&type=template&id=4a9b0ca3"
import script from "./DashboardMatters.vue?vue&type=script&lang=js"
export * from "./DashboardMatters.vue?vue&type=script&lang=js"
import style0 from "./DashboardMatters.vue?vue&type=style&index=0&id=4a9b0ca3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports